module.exports = __webpack_public_path__ + "assets/img/integruota-i-stoga.2578091a.webp";